import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { IntakeProvider, useIntake } from '../../contexts/IntakeContext'
import useUserIntakePreferencesFetcher from '../../hooks/useUserIntakePreferencesFetcher'
import { useSnackbar } from '../../hooks'
import { RequestService } from '../../services/RequestService'
import IntakeSleep from '../Intake/IntakeSleep'
import { ROUTES } from '../../routes'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  padding: 44px;
`

const SleepStep = () => {
  const { data } = useUserIntakePreferencesFetcher()
  const { sleepTime, setSleepTime, setAwakeTime, awakeTime } = useIntake()
  const navigate = useNavigate()
  const { t } = useTranslation('common')

  useEffect(() => {
    if (data) {
      const { sleepTime, awakeTime } = data

      const newSleepTime = new Date()
      const newAwakeTime = new Date()

      if (sleepTime) {
        newSleepTime.setHours(sleepTime.getHours(), sleepTime.getMinutes(), 0)
      }

      if (awakeTime) {
        newAwakeTime.setHours(awakeTime.getHours(), awakeTime.getMinutes(), 0)
      }

      if (sleepTime && awakeTime) {
        if (newSleepTime >= newAwakeTime) {
          setSleepTime(new Date(newSleepTime.getTime() - 1000 * 60 * 60 * 24))
        } else {
          setAwakeTime(newSleepTime)
        }
        setAwakeTime(newAwakeTime)
      }
    }
  }, [data])

  const { errorSnackbar } = useSnackbar()

  const handleFinish = async () => {
    const { status, data } = await RequestService.saveUserIntake({
      sleepTime,
      awakeTime,
    })

    if (status === RequestService.STATUSES.SUCCESS) {
      navigate(ROUTES.USER_DASHBOARD)
    } else {
      errorSnackbar({ text: data.message })
    }
  }

  return (
    <Container>
      <IntakeSleep
        step={t('steps.one')}
        onNext={() => handleFinish()}
        onPrevious={() => navigate(ROUTES.USER_DASHBOARD)}
        hideNotSleepButton
        sleepTime={sleepTime}
        setSleepTime={setSleepTime}
        awakeTime={awakeTime}
        setAwakeTime={setAwakeTime}
      />
    </Container>
  )
}

const Sleep = () => {
  return (
    <IntakeProvider>
      <SleepStep />
    </IntakeProvider>
  )
}

export default Sleep
